// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__12oz7","icon":"SortAdornment_icon__3dIok","up":"SortAdornment_up__3zGpi","down":"SortAdornment_down__3ubJD","active":"SortAdornment_active__surSw"};